import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "География. 7 класс",
        subject: "Взаимосвязь тем «Атмосфера и климаты Земли» и «Взаимодействие природы и общества»",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Взаимосвязь тем «Атмосфера и климаты Земли» и «Взаимодействие природы и общества»",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Дюкова Светлана Евгеньевна",
                grade: "научный сотрудник лаборатории социально-гуманитарного общего образования ФГБНУ «Институт стратегии развития образования»",
                subGrade: "",
                imageSrc: "./images/author1.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: "<p style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>Выбор тем обусловлен, в первую очередь, их значимостью на современном этапе развития общества, возможностями продемонстрировать связь географии с решением реальных проблем, которые стоят перед человечеством. </p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>Эта тема важна для достижения личностных результатов обучения, связанных с экологическим воспитанием и формированием ценностных ориентаций, в том числе:</p>"
                        },
                        {
                            type: "block",
                            listLabel: "<p style='padding-left: 2.4rem;'>В 10–11 классах предусмотрено два уровня изучения информатики: базовый и углубленный. Независимо от уровня изучения информатики в результате необходимо обеспечить у выпускников школы сформированность: </p>",
                            unorderedList: [
                                "осознания глобального характера проблемы изменения климата и выбора путей её решения; ",
                                "осознания своей роли как гражданина и потребителя в условиях взаимосвязи природной, технологической и социальной сред; ",
                                "готовность к участию в практической деятельности экологической направленности. "
                            ]
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>В видеоролике демонстрируются линии связи тем «Взаимодействие природы и общества» и «Атмосфера и климаты Земли» через планируемые результаты освоения программы, показаны эффективные способы формирования предметных  и метапредметных результатов, представлены примеры реальных проблем, связанных с изменениями климата на территории мира и России, которые могут быть использованы при формировании функциональной грамотности на предметном содержании.  </p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>Изучение данных тем в 7 классе важно также как основа для изучения изменения климата как глобальной проблемы на территории России, где в 8-9 классах в курсе «Географии России» обучающиеся будут знакомиться с её проявлением и последствиями изменений климата территории России, её регионов, своего края. </p>"
                        }
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video.mp4",
            contentBefore: [{
                type: "text",
                text: `<p>Тема «Атмосфера и климаты Земли» важна для достижения планируемых результатов, среди которых есть связанные с глобальной проблемой изменения климата и деятельности общества для снижения рисков его последствий.  И это не только знание о парниковых газах, механизма парникового эффекта, умение объяснить климат территории. Это отношения и чувства. Это желание внести свой вклад в устойчивое развитие своей страны и планеты.</p>
                        <p>Один из планируемых результатов для 7 класса – это умение формулировать оценочные суждения о последствиях изменений компонентов природы в результате деятельности человека с использованием разных источников географической информации.</p>
                        <p>В тематическом планировании предлагаются виды деятельности, которые помогут организовать образовательный процесс, направленный на достижение этого результата, среди которых: </p>
                        <p>
                            <ul>
                                <li>выявлять признаки изменения климата;</li>
                                <li>выявлять закономерности и противоречия в рассматриваемых фактах;</li>
                                <li>выявлять дефицит географической информации, выражать свою точку зрения на существование глобальных климатических изменений и так далее.</li>
                            </ul>
                        </p>
                        <p>Эти виды деятельности предполагают организацию обсуждения проблемы изменения климата, свободного обмена мнениями на основе анализа информации.</p>
                        <p>Какие источники информации требуется подобрать для такого урока? Исходя из планируемого результата и видов деятельности, источники информации должны обеспечить возможность формирования умений поставить географические вопросы, выявить противоречивую информацию, найти аргументы для подтверждения разных точек зрения на проблему изменения климата, сформировать своё мнение. </p> 
                        <p>Также отметим требования, связанные с возможностью формирования личного отношения к проблеме, которое приведёт к тому, что обучающиеся в будущем будут сознательно выбирать стратегии поведения, приводящие к устойчивому развитию своей страны и планеты.  </p>
                        <p>Как можно организовать урок, исходя из поставленных задач?</p>   
                    `
            }],
            contentAfter: [{
                type: "text",
                text: ``
            }]
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1011",
            title: "Практический модуль",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 5,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Комплект материалов «климатическая шкатулка». URL. https://climate-box.com/ru/toolkit-2/ (дата обращения 20.03. 2023)",
                "Новости ООН. В ООН призывают вкладывать больше средств в проекты по адаптации к последствиям глобального потепления. URL. https://news.un.org/ru/story/2022/11/1434287  (дата обращения 15.03. 2023)",
                "Климатический хаос. Чем грозит человечеству потепление, и что делать для предотвращения катастрофы.  URL. https://tass.ru/spec/climatehttps://tass.ru/spec/climate (дата обращения 20.02. 2023)",
                "Фонд климатической безопасности. Конкурс детских рисунков «Изменение климата глазами детей». URL. https://www.climatesecurity.org/ru/contests/konkurs-risunkov (дата обращения 20.04. 2023)",
                "Пресс-релиз межправительственной группы экспертов по изменению климата «Срочные меры по борьбе с изменением климата могут обеспечить пригодное для жизни будущее для всех». URL. https://www.ipcc.ch/report/ar6/syr/downloads/press/IPCC_AR6_SYR_PressRelease_ru.pdf  (дата обращения 20.04. 2023)",
                "Что такое изменение климата. URL. https://www.un.org/ru/climatechange/what-is-climate-change (дата обращения 19.04. 2023)",
                "Финансирование деятельности по борьбе с изменением климата. URL. https://www.un.org/ru/climatechange/raising-ambition/climate-finance (дата обращения 20.12. 2022)",
                "И.Мишина.  Лёд тронулся: какие природные аномалии ждут Россию и мир в ближайшее время / Новые известия.  URL. https://www.kp.ru/family/ecology/izmenenie-klimata/ (дата обращения 26.04. 2023)",
                "Засуха. МЧС России. URL. https://50.mchs.gov.ru/deyatelnost/deyatelnost/zasuha (дата обращения 20.12. 2022)",
                "Л.Н. Карлин, И.Н. Самусевич. Глобальный климат, история и культура // Общество. Среда. Развитие (Terra Humana). 2010. №1. URL. https://cyberleninka.ru/article/n/globalnyy-klimat-istoriya-i-kultura (дата обращения: 28.04.2023).",
                "COP27 завершился историческим соглашением по созданию фонда компенсации ущерба климату в развивающихся странах. URL. https://ecosphere.press/2022/11/20/cop27-zavershilas-istoricheskim-soglasheniem-po-sozdaniyu-fonda-kompensaczii-ushherba-klimatu-v-razvivayushhihsya-stranah/ (дата обращения 26.04. 2023)",
                "Be a climate action superhero! (на англ. яз.). URL. https://www.un.org/sustainabledevelopment/climate-action-superheroes-info/#fumefighter  (дата обращения 20.12. 2022)",
            ],
            sites: [
                ""
            ],
            filesToDownload: [
                {
                    link: "./files/additional.pdf",
                    fileName: "Задания по темам «Атмосфера и климаты Земли» и «Взаимодействие природы и общества»"
                }
            ]
        }
    ],
};
